import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Kolkata";

export function fmtDateTime(iso) {
  if (!iso) return "—";
  return dayjs(iso).tz(TZ).format("DD MMM YYYY, hh:mm A") + " IST";
}

export function fmtDate(iso) {
  if (!iso) return "—";
  return dayjs(iso).tz(TZ).format("DD MMM YYYY");
}

export function fmtTime(iso) {
  if (!iso) return "—";
  return dayjs(iso).tz(TZ).format("hh:mm A");
}

export function fromNow(iso) {
  if (!iso) return "";
  const diff = dayjs().diff(dayjs(iso), "minute");
  if (diff < 1) return "just now";
  if (diff < 60) return `${diff}m ago`;
  const h = Math.floor(diff / 60);
  if (h < 24) return `${h}h ago`;
  return dayjs(iso).tz(TZ).format("DD MMM");
}
